// Copyright (C) 2019 TANNER AG

import React, { useContext } from "react";
import * as PropTypes from "prop-types";
import classnames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { BusImage } from "../../components/busimage";
import { TranslationContext } from "../../translation";

const styles = {
	item: {
		flexBasis: 0,
		flexGrow: 1,
		width: "100%",
		maxWidth: "100%",
		transition: "opacity 1s 0.3s",
		"& > div": {
			display: "flex",
			alignItems: "center",
			padding: "0 20px",
			justifyContent: "flex-end"
		},
		"&:first-child > div": {
			flexDirection: "row-reverse",
			paddingRight: 20
		},
		"&:nth-child(2) > div": {
			paddingLeft: 20
		},
		"&.disabled": {
			opacity: "0.6",
			touchAction: "none",
			pointerEvents: "none"
		}
	},
	image: {
		height: 50,
		width: "100px",
		backgroundColor: "rgba(255,255,255,0.5)",
		"& > img": {
			width: "auto",
			height: "100%",
			boxShadow: "0 2px 4px 0 rgba(0,0,0,0.5)",
			borderRadius: 2
		}
	},
	name: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: "bold",
		fontStretch: "condensed",
		color: "#303C49",
		fontSize: 22,
		lineHeight: "30px",
		textAlign: "center"
	},
	enquirer: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: 300,
		color: "#303C49",
		fontSize: "22px",
		lineHeight: "30px",
		textAlign: "center"
	},
	description: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: 300,
		color: "#303C49",
		fontSize: 15,
		lineHeight: "22px",
		textAlign: "center"
	}
};

export const HeaderItem = withStyles(styles)((props) => {
	const { classes, name, doors, fuel, type, number, disabled, onClick } = props;
	const { translate } = useContext(TranslationContext);
	return (
		<div className={classnames(classes.item, { disabled })} onClick={onClick}>
			<div className={classes.itemInner}>
				<div style={{ width: "60%" }}>
					{props.name ? (
						<React.Fragment>
							<div className={classes.name}>{name}</div>
							<div className={classes.description}>
								{`${doors} ${translate("common.doors")}`}, {fuel}
							</div>
						</React.Fragment>
					) : (
						<div className={classes.enquirer}>{translate("calculator.vehicle")} {number}</div>
					)}
				</div>
				<div className={classes.image}>
					<BusImage
						name={name}
						fuel={fuel}
						type={type}
					/>
				</div>
			</div>
		</div>
	);
});

HeaderItem.propTypes = {
	name: PropTypes.string,
	doors: PropTypes.number,
	fuel: PropTypes.string,
	type: PropTypes.string,
	number: PropTypes.number,
	disabled: PropTypes.bool,
	onClick: PropTypes.func
};






// WEBPACK FOOTER //
// ./src/tco/entry/header/item.js